import main from "../../assets/img/oceanicons.jpg"

export default function OceanAnimals() {
    return (
        <main className="portfolioDetail">
            <h1>Ocean Animals - Icon Design</h1>
            <img src={main} alt="project information" loading="lazy" />
        </main>
    );
  }